import { Activity } from 'react'
import { Panel } from 'react-resizable-panels'

import { CollapsibleResizeHandle } from '../../components/collapsibleResizeHandle/CollapsibleResizeHandle'
import { useLayoutContext } from '../../context/layoutContext'
import { GlMapSidebar } from './GlMapSidebar'

export const GlMapSidebarPanel = () => {
  const { onChangeView, preferences } = useLayoutContext()
  const {
    glMaps: { isSidebarOpen },
  } = preferences

  const handleToggleSidebar = () => {
    onChangeView({
      ...preferences,
      glMaps: { ...preferences.glMaps, isSidebarOpen: !isSidebarOpen },
    })
  }

  return (
    <>
      <Activity mode={isSidebarOpen ? 'visible' : 'hidden'}>
        <Panel
          className="size-full overflow-hidden"
          id="glMapVersionsPanel"
          defaultSize="20%"
          minSize="5%"
        >
          <GlMapSidebar />
        </Panel>
      </Activity>
      <CollapsibleResizeHandle
        id="resizeGlMapVersionsBar"
        isOpen={isSidebarOpen}
        onToggle={handleToggleSidebar}
      />
    </>
  )
}
